import { route } from "./route-paths.utils";

export const routePaths = {
  base: route(""),
  login: route("login"),

  procedures: route("procedures"),
  // The literal `views` segment keeps a slug from being swallowed by
  // `procedure: route("procedures/:id")` and parsed as a procedure id.
  procedureViewsIndex: route("procedures/views"),
  procedureViews: route("procedures/views/:viewSlug"),
  // The detail path and the pattern that serves it. Same split, same reason as
  // `messages` / `messagesConversation` / `messagesRoutePattern` below: the two
  // explicit paths are what `generatePath` builds links from, and the single
  // optional-param entry is the only thing REGISTERED — sibling entries would
  // put the screen at a different route on either side of the first row click,
  // remounting it and losing the table's filters, search and scroll position.
  procedureViewDetail: route("procedures/views/:viewSlug/:detailId"),
  procedureViewsRoutePattern: route("procedures/views/:viewSlug/:detailId?"),
  newProcedure: route("procedures/new"),
  batches: route("batches"),
  newBatch: route("batches/new"),
  reports: route("reports"),
  newReport: route("reports/new"),
  report: route("reports/:id"),
  procedureBatch: route("batches/:id"),
  procedureBatchProcedures: route("batches/:id/procedures"),
  procedureBatchDocuments: route("batches/:id/documents"),
  energySavingCertificates: route("energy-saving-certificates"),
  energySavingCertificate: route("energy-saving-certificates/:id"),
  energySavingCertificateVehicles: route(
    "energy-saving-certificates/:id/vehicles",
  ),
  energySavingCertificateSteps: route("energy-saving-certificates/:id/steps"),
  newEnergySavingCertificate: route("energy-saving-certificates/new"),
  newEnergySavingCertificateTRA020: route(
    "energy-saving-certificates/new/tra020",
  ),
  newEnergySavingCertificateWithId: route("energy-saving-certificates/new/:id"),
  procedure: route("procedures/:id"),
  procedureSteps: route("procedures/:id/steps"),
  customers: route("customers"),
  newCustomer: route("customers/new"),
  newCustomerWithId: route("customers/new/:id"),
  customer: route("customers/:id"),
  customerUsers: route("customers/:id/users"),
  customerCustomers: route("customers/:id/customers"),
  customerSettings: route("customers/:id/settings"),
  protected: route("protected"),
  settings: route("settings"),
  logout: route("logout"),
  export: route("export"),

  // Tax liquidation methods
  taxLiquidationMethods: route("tax-liquidation-methods"),
  newTaxLiquidationMethod: route("tax-liquidation-methods/new"),
  taxLiquidationMethod: route("tax-liquidation-methods/:id"),

  // Signatures
  signatures: route("signatures"),
  newSignature: route("signatures/new"),
  editSignature: route("signatures/:id/edit"),

  // Messages (unified inbox). The two above are what LINKS are built from — the
  // navigation entry and `generatePath` for a selection. The one below is the
  // single route ENTRY that serves both, and the optional parameter is what
  // makes it one: registering the two patterns as sibling entries puts the
  // screen at a different route on either side of the first selection, which
  // remounts it and takes the filters and the search with it.
  messages: route("messages"),
  messagesConversation: route("messages/:conversationId"),
  messagesRoutePattern: route("messages/:conversationId?"),

  // Customer service
  customerService: route("customer-service"),

  // Deliveries
  deliveryNote: route("deliveries/:deliveryTrackingId/delivery-note"),
  newDelivery: route("deliveries/new"),

  // Commander (developer tool)
  commander: route("commander"),
};
